























import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ThemeConfModule } from '@/store/modules/theme';
import { formatPercent } from '@/author/components/helper/i18n';

const AppState = getModule(AppModule, store);
const ThemeConf = getModule(ThemeConfModule, store);

@Component
export default class FeedbackSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;
  @Prop() backgroundImage?: string;
  @Prop() theme?: string;
  @Prop({ default: 'center' }) align?: string;
  @Prop({ default: 'full' }) layout?: string;
  @Prop({ default: 0 }) padding?: string;
  @Prop({ default: 'normal' }) size?: string;
  @Prop(String) hiddenTitle!: string;

  @Prop(String) positiveTitle!: string;
  @Prop(String) positiveSubtitle!: string;
  @Prop(String) positiveMessage!: string;
  @Prop(String) positiveImage!: string;
  @Prop(String) positiveImageAlt!: string;

  @Prop(String) negativeTitle!: string;
  @Prop(String) negativeSubtitle!: string;
  @Prop(String) negativeMessage!: string;
  @Prop(String) negativeImage!: string;
  @Prop(String) negativeImageAlt!: string;

  get scorePercentage() {
    return formatPercent(AppState.getScore / AppState.getTotalScore);
  }

  hasPass() {
    return AppState.getScore / AppState.getTotalScore >= ThemeConf.passingScore;
  }

  getTheme() {
    return {
      'color-light-text': this.theme == 'light',
      'color-dark-text': this.theme == 'dark',
      'color-primary': this.theme == 'primary'
    };
  }

  parseScoredText(text: string) {
    return text
      .replace(/\{score\}/g, AppState.getScore.toString())
      .replace(/\{totalScore\}/g, AppState.getTotalScore.toString())
      .replace(/\{scorePercentage\}/g, this.scorePercentage.toString());
  }
}
